import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { loginUser } from "../../../store/actions"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"
import { gtmTrackRegistration } from '../../../Utils/gtm'

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Terms = props => {
  // Reload the page once when the user visits this page
  React.useEffect(() => {
    if (!sessionStorage.getItem('terms_page_reloaded')) {
      sessionStorage.setItem('terms_page_reloaded', true);
      window.location.reload();
    }
    return () => {
      sessionStorage.setItem('terms_page_reloaded', '');
    };
  }, []);
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const { referral_code } = useParams()
  const location = useLocation()
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => setShowModal(!showModal)
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [formData1, setFormData1] = React.useState({
    country: { label: "Spain", value: "Spain" },
    country_code: { id: 212, title: "ES +34", code: "ES", value: 34 },
  })
  const [CustomError1, setCustomError1] = React.useState({
    country: "",
    country_code: "",
  })
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      mailchimp: false,
      terms: false,
    },
    validationSchema: Yup.object({
      terms: Yup.boolean().oneOf(
        [true],
        i18next.t("You must accept the terms and conditions to continue!"),
      ),
    }),
    onSubmit: async values => {
      try {
        let submit1 = document.getElementById("submit1")
        submit1.disabled = true
        submit1.textContent = i18next.t("Processing...")
        const jsonpar = JSON.stringify({
          u_id: UID,
          mailchimp: values.mailchimp,
        })

        const res = await postRequestWOAccessToken(
          "signup-terms-conditions",
          jsonpar,
        )
        if (res && res.code === 200) {
          let originalText = res.data
          gtmTrackRegistration(UID, 'email_password');
          toggleModal()
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit1.disabled = false
        submit1.textContent = i18next.t("Create Account")
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const LoginAfterRegister = async () => {
    const jsonpar = JSON.stringify({
      u_id: UID,
    })

    const res = await postRequestWOAccessToken("login-after-register", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data

      i18next.changeLanguage(originalText.preferred_language)
      localStorage.setItem("I18N_LANGUAGE", originalText.preferred_language)

      localStorage.setItem("Collaborator", "false")
      if (originalText.collaborator) {
        localStorage.setItem("Collaborator", "true")
      }
      let values = {
        username: originalText.first_name + " " + originalText.last_name,
        kyc_status: originalText.kyc_status,
        accesstoken: originalText.accesstoken,
        refreshtoken: originalText.refreshtoken,
        kyc: false
      }

      dispatch(
        loginUser(values, props.history, {
          code: 200,
          status: "success",
          message: i18next.t("Login PG Login successful Only"),
        }),
      )
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

    const KYCAfterRegister = async () => {
    const jsonpar = JSON.stringify({
      u_id: UID,
    })

    const res = await postRequestWOAccessToken("login-after-register", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data

      i18next.changeLanguage(originalText.preferred_language)
      localStorage.setItem("I18N_LANGUAGE", originalText.preferred_language)

      localStorage.setItem("Collaborator", "false")
      if (originalText.collaborator) {
        localStorage.setItem("Collaborator", "true")
      }
      let values = {
        username: originalText.first_name + " " + originalText.last_name,
        kyc_status: originalText.kyc_status,
        accesstoken: originalText.accesstoken,
        refreshtoken: originalText.refreshtoken,
        kyc: true
      }

      dispatch(
        loginUser(values, props.history, {
          code: 200,
          status: "success",
          message: i18next.t("Login PG Login successful Only"),
        }),
      )
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([])
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState(
    [],
  )
  const handleLoadGetAllCountries = async () => {
    const res = await getRequestWOAccessToken("get-all-countries")
    if (res && res.code === 200) {
      let originalText = res.data

      let tempArr = []
      originalText.forEach(element => {
        let temp = {
          label: element.country_name,
          value: element.country_name,
        }
        tempArr.push(temp)
      })
      tempArr = [
        {
          options: tempArr,
        },
      ]
      setAllCountriesCustomData2(tempArr)

      tempArr = []
      originalText.forEach(element => {
        let temp = {
          id: element.id,
          title: element.country_code + " +" + element.phone_code,
          code: element.country_code,
          value: element.phone_code,
        }
        tempArr.push(temp)
      })
      setAllCountriesCustomData(tempArr)
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }
  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }

  const handleLoadGetSignupStatus = async u_id => {
    const jsonpar = JSON.stringify({
      u_id: u_id,
    })

    const res = await postRequestWOAccessToken("signup-status", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data
      if (originalText.is_email_verified == 0) {
        history.push("/email-verification", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.phone == "" ||
        originalText.phone == null ||
        originalText.phone == undefined
      ) {
        history.push("/add-phone", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.is_phone_verified == 0) {
        history.push("/phone-verification", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.first_name == null ||
        originalText.first_name == "" ||
        originalText.last_name == null ||
        originalText.last_name == ""
      ) {
        history.push("/personal-details", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.address == null || originalText.address == "") {
        history.push("/address", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.tax_id == null || originalText.tax_id == "") {
        history.push("/tax", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.accept_terms == "false") {
        return
      } else {
        history.push("/login")
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
  }

  const [UID, setUID] = React.useState(0)
  const [Email, setEmail] = React.useState("")
  const [CountryCode, SetCountryCode] = React.useState("")
  const [Phone, setPhone] = React.useState("")
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) setPreferredLanguage("sp")
    else setPreferredLanguage(language)

    handleLoadGetAllCountries()

    if (referral_code) {
      validation1.setValues({
        ...validation1.values,
        referral_code: referral_code,
      })
    }
    if (
      typeof location.state !== "undefined"
    ) {
      handleLoadGetSignupStatus(location.state.id)
      handleLoadGetAllCountries(location.state.country_code)
      setUID(location.state.id)
      setEmail(location.state.email)
      SetCountryCode(location.state.country_code)
      setPhone(location.state.phone)
      if(location.state.message){
        setAlertData(AlertData => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }))
        resetAlertData()
      }
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        {/* <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select> */}
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="text-primary p-4">
                      <h2 className="text-black mb-3">
                        {i18next.t("Terms & Consents")}
                      </h2>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={12}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="termsCheckbox"
                                name="terms"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                checked={validation1.values.terms}
                              />
                              <label
                                className="form-check-label d-inline"
                                htmlFor="termsCheckbox"
                              >
                                <a
                                  href={`${process.env.REACT_APP_FRONTEND_URL}terminos-de-uso`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-green text-underline"
                                >
                                  {i18next.t(
                                    "I agree to Terms & Conditions and Privacy Policy.",
                                  )}
                                </a>
                              </label>
                              {validation1.touched.terms &&
                              validation1.errors.terms ? (
                                <FormFeedback type="invalid">
                                  {validation1.errors.terms}
                                </FormFeedback>
                              ) : null}
                            </Col>
                          </div>

                          <div className="row">
                            <Col md={12}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="mailchimpCheckbox"
                                name="mailchimp"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                checked={validation1.values.mailchimp}
                              />
                              <label
                                className="form-check-label d-inline"
                                htmlFor="mailchimpCheckbox"
                              >
                                {i18next.t("subscribe_newsletter")}
                              </label>
                              {/* {validation1.touched.mailchimp && validation1.errors.mailchimp ? (
                                <FormFeedback type="invalid">{validation1.errors.mailchimp}</FormFeedback>
                              ) : null} */}
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                e.preventDefault()
                                validation1.handleSubmit()
                                return false
                              }}
                              data-toggle="modal"
                              data-target="#myModal"
                              className="btn btn-primary btn-block"
                            >
                              {" "}
                              {i18next.t("Create Account")}{" "}
                            </Button>
                          </div>
                        </div>
                        <div className="mt-3 text-center">
                          <p className="mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenized Green.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
      <Modal centered backdrop="static" isOpen={showModal} toggle={toggleModal}>
        <div className="modal-header border-0 justify-content-center">
          <h4 className="modal-title fw-bold text-center m-0">
            {i18next.t("Congratulations")}
          </h4>
          <button
            type="button"
            onClick={toggleModal}
            className="btn-close position-absolute end-0 me-3"
            aria-label="Close"
          />
        </div>

        <div className="modal-body text-center">
          <h2 className="mb-4 fw-semibold">
            {i18next.t("Welcome to the revolution of sustainable investing")}
          </h2>

          <p className="mb-4 fw-semibold">
            {i18next.t("Your account is now open and ready to use")}
          </p>

          <div className="d-grid gap-3">
            <Button
              id="startBtn"
              color="primary"
              size="md" // 🔹 set to medium for smaller size
              onClick={() => {
                toggleModal()
                KYCAfterRegister()
              }}
            >
              {i18next.t("Start")}
            </Button>

            <label
              className="form-check-label d-inline"
              htmlFor="customControlInline"
            >
              <a
                href={`${process.env.REACT_APP_FRONTEND_URL}terminos-de-uso`}
                target="_blank"
                rel="noreferrer"
                className="text-green text-underline"
                onClick={(e) => {
                  e.preventDefault() // prevent immediate navigation
                toggleModal()
                LoginAfterRegister()
              }}
            >
                {i18next.t("Skip")}
              </a>
            </label>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default Terms
